import { SmsInviteStatus } from '@tmx/data-access';

import { LicenseUser } from '../../models/license-user';

export const mapSmsStatusesToAssets = (
  smsStatuses: SmsInviteStatus[],
  assets: LicenseUser[]
) => {
  for (const asset of assets) {
    const smsStatus = smsStatuses.find(
      (responseRow) => asset.externalId === responseRow.entityId
    );
    if (smsStatus) {
      asset.smsStatus = smsStatus;
    }
  }
  return assets;
};
